<div class="row p-3">
  <div class="col-12 text-center pt-4">
    <img src="/assets/svg/success-subscribe.svg" alt="success-subscribe-image" />
  </div>
  <div class="col-12 text-primary p-2 text-center">
    <h5>{{ successMessage | translate }}</h5>
  </div>
  <div class="col-12 p-2">
    <p class="text-center">{{ thanksMessage | translate }}</p>
  </div>
  <div class="col-12 text-center">
    <button class="btn btn-primary" (click)="goToHomePage()">{{"directory.goToHome" | translate}}</button>
  </div>
</div>